exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AssetAllocationFunds__sliderHolder {\n  margin: 0 25px; }\n  .AssetAllocationFunds__sliderHolder .slick-next::before {\n    content: none; }\n  .AssetAllocationFunds__sliderHolder .slick-prev::before {\n    content: none; }\n\n.AssetAllocationFunds__donut {\n  background-color: #dddddd29;\n  border: 1px solid #aaa;\n  height: 500px; }\n  @media only screen and (min-width: 1220px) {\n    .AssetAllocationFunds__donut {\n      height: 570px; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/pages/Create_portfolio_by_Advisor/asset_allocation_funds/AssetAllocationFunds.style.scss
// module id = 1632
// module chunks = 0